import * as R from "ramda";

export const groups = R.path(["items", "zoneGroups", "groups"]);
